import React from 'react';
import './LandingNews.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import NewsData from '../../Components/Article/NewsReleases.json';

interface NewsItem {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  author: { name: string };
  publishedAt: string;
  tags: string[];
}

const formatDate = (iso: string) =>
  new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

const LandingNews: React.FC = () => {
  const items = [...(NewsData as NewsItem[])]
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(0, 3);

  return (
    <section className='landing-news-section'>
      <div className='landing-news-header'>
        <h2 className='landing-news-title'>Latest News</h2>
        <Link to="/news" className='landing-news-view-all'>
          View All <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>

      <div className='landing-news-grid'>
        {items.map((item) => (
          <Link key={item.id} to={`/article/${item.slug}`} className='landing-news-card'>
            <div className='landing-news-card-tags'>
              {item.tags.slice(0, 2).map((tag) => (
                <span key={tag} className='landing-news-tag'>{tag}</span>
              ))}
            </div>
            <h3 className='landing-news-card-title'>{item.title}</h3>
            <p className='landing-news-card-excerpt'>
              {item.excerpt.length > 145 ? item.excerpt.slice(0, 145) + '…' : item.excerpt}
            </p>
            <div className='landing-news-card-footer'>
              <span className='landing-news-date'>{formatDate(item.publishedAt)}</span>
              
            </div>
            <span className='landing-news-read-more'>
                Read more <FontAwesomeIcon icon={faArrowRight} />
              </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default LandingNews;
